import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import type { IAgent } from '@/store/types';

import { LoaderWrapper, Table } from '@/components/common';
import { media } from '@/styles/theme';
import { AgentsTableSkeleton } from './AgentsTable.skeleton';
import { AgentRow } from '@/components/client/contracts';

interface IAgentsTable {
  agents: IAgent[];
  onRowSelect: (userId: number) => void;
  isLoading: boolean;
}

export interface IAgentsTableConfig {
  icon: { width: string };
  labelFirstName: { width: string };
  labelLastName: { width: string };
  labelStartDate: { width: string };
  button: { width: string };
}

const tableConfig: IAgentsTableConfig = {
  icon: { width: '14px' },
  labelFirstName: { width: '30%' },
  labelLastName: { width: '30%' },
  labelStartDate: { width: '30%' },
  button: { width: '30px' },
};

const AgentsTable = ({ agents, onRowSelect, isLoading }: IAgentsTable): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <Container>
      <LoaderWrapper isLoading={isLoading} loader={<AgentsTableSkeleton />}>
        <Table minWidth={900} type="scrolling">
          <Table.Header>
            <HeaderIconCell width={tableConfig.icon.width} />
            <Table.HeaderCell
              width={tableConfig.labelFirstName.width}
            >{t`clientGigs.agentsTable.labelFirstName`}</Table.HeaderCell>
            <Table.HeaderCell
              width={tableConfig.labelLastName.width}
            >{t`clientGigs.agentsTable.labelLastName`}</Table.HeaderCell>
            <Table.HeaderCell
              className="hide-on-small-screen"
              width={tableConfig.labelStartDate.width}
            >{t`clientGigs.agentsTable.labelStartDate`}</Table.HeaderCell>
            <Table.HeaderCell width={tableConfig.button.width} />
          </Table.Header>
          {agents.map(agent => (
            <AgentRow key={agent.userId} agent={agent} onRowSelect={onRowSelect} tableConfig={tableConfig} />
          ))}
        </Table>
      </LoaderWrapper>
    </Container>
  );
};

export { AgentsTable };

const Container = styled.div`
  padding: 0 30px;

  .row-pointer {
    cursor: pointer;
  }
`;

const HeaderIconCell = styled(Table.HeaderCell)`
  display: none;

  ${media.laptop} {
    display: initial;
  }
`;
